import React from 'react';

import { IMAGES } from '../../enum';
import Tooltip from '../Tooltip';
import classNames from './style.module.scss';

const TripSourceTrackIconsRow = props => {
  const { t, isGpsVerifiedReceipt, isManualReceipt } = props;

  if (isManualReceipt) {
    return (
      <div className={classNames.iconsRow}>
        <Tooltip title={t('manuallyCreatedTrips')}>
          <img alt="manual trip track" src={IMAGES.MANUAL_TRACK_ICON} />
        </Tooltip>
      </div>
    );
  }

  if (isGpsVerifiedReceipt) {
    return (
      <div className={classNames.iconsRow}>
        <Tooltip title={t('trackedUsingMobileApp')}>
          <img alt="mobile track" src={IMAGES.MOBILE_TRACK_ICON} />
        </Tooltip>
      </div>
    );
  }

  return (
    <div className={classNames.iconsRow}>
      <Tooltip title={t('trackedUsingMobileApp')}>
        <img alt="mobile track" src={IMAGES.MOBILE_TRACK_ICON} />
      </Tooltip>
      <Tooltip title={t('manuallyCreatedTrips')}>
        <img alt="manual trip track" src={IMAGES.MANUAL_TRACK_ICON} />
      </Tooltip>
    </div>
  );
};

export default TripSourceTrackIconsRow;
